import React from 'react';
import { Popover } from 'antd';

const SbPopover = ({ children, ...props }) => {
    return <Popover {...props}>{children}</Popover>;
};

export default SbPopover;
